import React from 'react'
import { handleAccount } from "./getCreateAccLink";

export const SignUp = ({content, lang}) => {
    return (
        <div className='sighup-wrapper'>
            <h1>{content.title}</h1>
            <button className='open-btn' onClick={handleAccount(lang)}>{content.open_an_account}</button>
        </div>
    )
}